import { createQrCode } from 'api/QRCode';

import type { FormType } from '..';

export const qrCodeForm: FormType = {
  createFn: createQrCode,
  cancelText: 'Cancelar',
  submitText: 'Salvar Códigos',
  disableText: 'Excluir Códigos',
  successText: 'Códigos salvos com sucesso!',
  fields: [
    [
      {
        name: 'name',
        type: 'text',
        required: true,
        props: {
          placeholder: 'Nome',
          label: 'Nome do grupo:',
        },
      },
      {
        name: 'amount',
        type: 'text',
        required: true,
        props: {
          placeholder: '100',
          label: 'Número de códigos:',
          type: 'number',
        },
      },
    ],
  ],
};
